import React, {useEffect, useState} from "react";
import {DEV_ACCESS_TOKEN} from "config";

const STORAGE_KEY = "dev_access_token";

export const DevAccessGuard = ({children}: { children: React.ReactNode }) => {
    const [authorized, setAuthorized] = useState<boolean | null>(null);
    const [inputValue, setInputValue] = useState("");
    const [error, setError] = useState(false);

    useEffect(() => {
        if (!DEV_ACCESS_TOKEN) {
            setAuthorized(true);
            return;
        }

        const params = new URLSearchParams(window.location.search);
        const accessFromUrl = params.get("access");

        if (accessFromUrl) {
            if (accessFromUrl === DEV_ACCESS_TOKEN) {
                localStorage.setItem(STORAGE_KEY, accessFromUrl);
                params.delete("access");
                const search = params.toString() ? `?${params.toString()}` : "";
                const newUrl = `${window.location.pathname}${search}${window.location.hash}`;
                window.history.replaceState({}, "", newUrl);
                setAuthorized(true);
                return;
            }
        }

        const storedToken = localStorage.getItem(STORAGE_KEY);
        if (storedToken === DEV_ACCESS_TOKEN) {
            setAuthorized(true);
            return;
        }

        setAuthorized(false);
    }, []);

    const handleSubmit = () => {
        if (inputValue === DEV_ACCESS_TOKEN) {
            localStorage.setItem(STORAGE_KEY, inputValue);
            setAuthorized(true);
            setError(false);
        } else {
            setError(true);
        }
    };

    if (authorized === null) return null;

    if (!authorized) {
        return (
            <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
                fontFamily: "system-ui, sans-serif",
                color: "#333",
                textAlign: "center",
                padding: "20px",
            }}>
                <h1 style={{fontSize: "48px", marginBottom: "16px", color: "#e74c3c"}}>403</h1>
                <h2 style={{fontSize: "24px", marginBottom: "12px"}}>Internal Use Only</h2>
                <p style={{fontSize: "16px", color: "#666", maxWidth: "400px", marginBottom: "24px"}}>
                    This environment is restricted. Please request an access link from the team or enter your access token below.
                </p>
                <div style={{display: "flex", gap: "8px"}}>
                    <input
                        type="password"
                        name="dev-access-token"
                        id={"dev-access-token"}
                        value={inputValue}
                        onChange={(e) => {
                            setInputValue(e.target.value);
                            setError(false);
                        }}
                        onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
                        placeholder="Access token"
                        style={{
                            padding: "10px 14px",
                            fontSize: "14px",
                            border: `1px solid ${error ? "#e74c3c" : "#ccc"}`,
                            borderRadius: "6px",
                            outline: "none",
                            width: "220px",
                        }}
                    />
                    <button
                        onClick={handleSubmit}
                        style={{
                            padding: "10px 20px",
                            fontSize: "14px",
                            backgroundColor: "#333",
                            color: "#fff",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                        }}
                    >
                        Enter
                    </button>
                </div>
                {error && (
                    <p style={{color: "#e74c3c", fontSize: "13px", marginTop: "8px"}}>
                        Invalid token
                    </p>
                )}
            </div>
        );
    }

    return <>{children}</>;
};
